import { CssBaseline, StyledEngineProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./global.css";
import ActiveClientProvider from "./providers/active-client-provider";
import { DirectusProvider } from "./providers/DirectusProvider";
import GraphqlProvider from "./providers/graphql-provider";
import KeycloakProvider from "./providers/keycloak-provider";
import LangProvider from "./providers/lang-provider";
import MuiThemeProvider from "./providers/MuiThemeProvider";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <KeycloakProvider>
    <LangProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL ?? ""}>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider>
            <CssBaseline />
            <ActiveClientProvider>
              <GraphqlProvider>
                <DirectusProvider apiUrl={process.env.REACT_APP_API_URL ?? ""}>
                  <App />
                </DirectusProvider>
              </GraphqlProvider>
            </ActiveClientProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </LangProvider>
  </KeycloakProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
